import {createContext, useContext} from 'react';
import {IPopupProviderInfoPopupParams} from "./PopupProvider.t";

interface IPopupContext {
    catchPopup: (e: any) => void,
    infoPopup: (message: IPopupProviderInfoPopupParams) => void,
}

export const PopupContext = createContext<IPopupContext>({
    catchPopup: () => {
    },
    infoPopup: () => {
    },
});
export const usePopupContext = () => {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('PopupContext cannot be used outside the PopupProvider')
    }
    return context;
}
